goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_counter_clockwise_svg$default");
shadow.js.shim.module$src$svg$arrows$arrow_counter_clockwise_svg$default = shadow.js.shim.module$src$svg$arrows$arrow_counter_clockwise_svg.default;
